module.exports = __webpack_public_path__ + "static/media/om_beard_stubble_square_black.228342c9.png";